<div class="pathway-step-item" *ngFor="let item of items$ | async">{{item.label}}</div>
